"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidCharacters = hasValidCharacters;
exports.isAlphabetic = isAlphabetic;
exports.isDateValid = isDateValid;
exports.isEmailValid = isEmailValid;
exports.isJsonValid = isJsonValid;
exports.isNonEmptyString = isNonEmptyString;
exports.isNumber = isNumber;
exports.isSameDate = isSameDate;
exports.isStringValid = isStringValid;
exports.isUrl = isUrl;
exports.logicalAndOperator = logicalAndOperator;
exports.logicalOrOperator = logicalOrOperator;
exports.ternaryCondition = ternaryCondition;
exports.validateArrivalDate = validateArrivalDate;
var _api = require("@whitbread-eos/api");
var _parse = _interopRequireDefault(require("date-fns/parse"));
function isStringValid(item) {
  return item !== null && item !== undefined && item !== '';
}
function isDateValid(day, month, year) {
  var date = (0, _parse.default)("".concat(day, " ").concat(month, " ").concat(year), 'dd MM yyyy', new Date());
  return !isNaN(date.getTime());
}
function isSameDate(firstDate, secondDate) {
  if (!firstDate || !secondDate) return false;
  return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
}
function isNumber(val) {
  return !isNaN(Number(val));
}
function isAlphabetic(val) {
  return /^[-A-Za-zÀ-ÖØ-ʒͰ-ͳͶ-ͷͻ-ͽvΑ-Ͽἀ-ῼЀ-ӿễấ ']+-?[\sA-Za-zÀ-ÖØ-ʒͰ-ͳͶ-ͷͻ-ͽvΑ-Ͽἀ-ῼЀ-ӿễấ ']*$/g.test(val);
}
function hasValidCharacters(val) {
  return /^[-A-Za-z0-9À-ÖØ-ʒͰ-ͳͶ-ͷͻ-ͽvΑ-Ͽἀ-ῼЀ-ӿễấ ']+-?[\sA-Za-zÀ-ÖØ-ʒͰ-ͳͶ-ͷͻ-ͽvΑ-Ͽἀ-ῼЀ-ӿễấ ']*$/g.test(val);
}
function isJsonValid(str) {
  try {
    var obj = JSON.parse(str);
    return obj && typeof obj === 'object';
  } catch (e) {
    return false;
  }
}
function ternaryCondition(condition, exprIfTrue, exprIfFalse) {
  return condition ? exprIfTrue : exprIfFalse;
}
function logicalAndOperator() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args === null || args === void 0 ? void 0 : args.reduce((acc, current) => acc && current, true);
}
function logicalOrOperator() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return args === null || args === void 0 ? void 0 : args.reduce((acc, current) => acc || current, false);
}
function isEmailValid(email) {
  var regex = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var isValidLength = email.length <= 50;
  return regex.test(email) && isValidLength;
}
function isUrl(url) {
  if (url) {
    try {
      return Boolean(new URL(url));
    } catch (_unused) {
      return false;
    }
  }
  return false;
}
function isNonEmptyString(str) {
  return !!str && str.trim() !== '';
}
function getMidnightInTimeZone(arrivalDate, timeZone) {
  var _parts$find, _parts$find2, _parts$find3;
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  var parts = fmt.formatToParts(new Date(arrivalDate + 'T12:00:00Z'));
  var year = Number((_parts$find = parts.find(p => p.type === 'year')) === null || _parts$find === void 0 ? void 0 : _parts$find.value);
  var month = Number((_parts$find2 = parts.find(p => p.type === 'month')) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value);
  var day = Number((_parts$find3 = parts.find(p => p.type === 'day')) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value);
  return new Date(year, month - 1, day, 0, 0, 0);
}
function validateArrivalDate(arrivalDate, hotelBrand) {
  var _nowParts$find, _nowParts$find2, _nowParts$find3, _nowParts$find4, _nowParts$find5, _nowParts$find6;
  var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
  var isGerman = hotelBrand === _api.HotelBrand.PID;
  var timeZone = isGerman ? 'Europe/Berlin' : 'Europe/London';
  var arrival = new Date(arrivalDate + 'T12:00:00Z');
  if (isNaN(arrival.getTime())) {
    return false;
  }
  var arrivalMidnightLocal = getMidnightInTimeZone(arrivalDate, timeZone);
  var cutoff = new Date(arrivalMidnightLocal.getTime() + (24 * 60 * 60 * 1000 - 1000));
  var nowParts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(now);
  var year = Number((_nowParts$find = nowParts.find(p => p.type === 'year')) === null || _nowParts$find === void 0 ? void 0 : _nowParts$find.value);
  var month = Number((_nowParts$find2 = nowParts.find(p => p.type === 'month')) === null || _nowParts$find2 === void 0 ? void 0 : _nowParts$find2.value);
  var day = Number((_nowParts$find3 = nowParts.find(p => p.type === 'day')) === null || _nowParts$find3 === void 0 ? void 0 : _nowParts$find3.value);
  var hour = Number((_nowParts$find4 = nowParts.find(p => p.type === 'hour')) === null || _nowParts$find4 === void 0 ? void 0 : _nowParts$find4.value);
  var minute = Number((_nowParts$find5 = nowParts.find(p => p.type === 'minute')) === null || _nowParts$find5 === void 0 ? void 0 : _nowParts$find5.value);
  var second = Number((_nowParts$find6 = nowParts.find(p => p.type === 'second')) === null || _nowParts$find6 === void 0 ? void 0 : _nowParts$find6.value);
  var localNow = new Date(year, month - 1, day, hour, minute, second);
  if (localNow < arrivalMidnightLocal) return true;
  if (localNow > cutoff) return false;
  return true;
}